import { TUpdateRetirementDateReqDto } from "@/api/services/main/retirement-document/dtos/update-retirement-date.dto";
import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { TRetirementEmployeeForm } from "@/features/retirement/types/retirementEmployeeForm";

export const convertResDtoToFormData = (data: TRetirementEmployeeForm): TUpdateRetirementDateReqDto => {
  return {
    retirementDate: data.retirementDate.format(DATE_NOT_TIMEZONE_FORMAT),
  };
};
